// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media (1600px <= width) {
    main {
        box-sizing: border-box;

        margin: 65px auto; /** push us below the header **/
        min-width: 375px;
        width: 100%;
        padding-top: 20px;
        padding-bottom: 50px;

        color: var(--main-text-color);
        background-color: var(--main-background-color);
    }
}

@media (1220px < width < 1600px) {
    main {
        box-sizing: border-box;

        margin: 65px auto; /** push us below the header **/
        min-width: 375px;
        width: 100%;
        padding-top: 20px;
        padding-bottom: 50px;

        color: var(--main-text-color);
        background-color: var(--main-background-color);
    }
}
@media (width <= 1220px) {
    main {
        box-sizing: border-box;

        margin: 65px auto; /** push us below the header **/
        min-width: 375px;
        width: 100%;
        padding-top: 10px;
        padding-bottom: 50px;

        color: var(--main-text-color);
        background-color: var(--main-background-color);
    }
}
`, "",{"version":3,"sources":["webpack://./client/layouts/MainLayout.css"],"names":[],"mappings":";AACA;IACI;QACI,sBAAsB;;QAEtB,iBAAiB,EAAE,+BAA+B;QAClD,gBAAgB;QAChB,WAAW;QACX,iBAAiB;QACjB,oBAAoB;;QAEpB,6BAA6B;QAC7B,8CAA8C;IAClD;AACJ;;AAEA;IACI;QACI,sBAAsB;;QAEtB,iBAAiB,EAAE,+BAA+B;QAClD,gBAAgB;QAChB,WAAW;QACX,iBAAiB;QACjB,oBAAoB;;QAEpB,6BAA6B;QAC7B,8CAA8C;IAClD;AACJ;AACA;IACI;QACI,sBAAsB;;QAEtB,iBAAiB,EAAE,+BAA+B;QAClD,gBAAgB;QAChB,WAAW;QACX,iBAAiB;QACjB,oBAAoB;;QAEpB,6BAA6B;QAC7B,8CAA8C;IAClD;AACJ","sourcesContent":["\n@media (1600px <= width) {\n    main {\n        box-sizing: border-box;\n\n        margin: 65px auto; /** push us below the header **/\n        min-width: 375px;\n        width: 100%;\n        padding-top: 20px;\n        padding-bottom: 50px;\n\n        color: var(--main-text-color);\n        background-color: var(--main-background-color);\n    }\n}\n\n@media (1220px < width < 1600px) {\n    main {\n        box-sizing: border-box;\n\n        margin: 65px auto; /** push us below the header **/\n        min-width: 375px;\n        width: 100%;\n        padding-top: 20px;\n        padding-bottom: 50px;\n\n        color: var(--main-text-color);\n        background-color: var(--main-background-color);\n    }\n}\n@media (width <= 1220px) {\n    main {\n        box-sizing: border-box;\n\n        margin: 65px auto; /** push us below the header **/\n        min-width: 375px;\n        width: 100%;\n        padding-top: 10px;\n        padding-bottom: 50px;\n\n        color: var(--main-text-color);\n        background-color: var(--main-background-color);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
